import { useEffect } from 'react';
import styled from 'styled-components';
import { useThumbnailManualReady } from '@elfsight/configurator-preview';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { usePaymentData } from '../payment/payment-data-provider';
import { useServices } from '../service/services-provider';
import { useDatetime } from './datetime-provider';
import { DaysCarousel } from './days-carousel';
import { SlotPickerSkeleton } from './slot-picker-skeleton';
import { TimeSlotPicker } from './time-slot-picker';

export function SlotPicker() {
  const { renderThumbnailMode } = useSettings();
  const { selectedDay, setSelectedTimeslot, isInitialLoading } = useDatetime();
  const { setCurrentStepToForm } = usePaymentData();
  const { services } = useServices();

  const [enableThumbnailReady, resolveThumbnailReady] =
    useThumbnailManualReady(renderThumbnailMode);

  useEffect(() => {
    enableThumbnailReady();
    setCurrentStepToForm();
  }, []);

  useEffect(() => {
    if (!isInitialLoading) {
      resolveThumbnailReady();
    }
  }, [isInitialLoading]);

  if (isInitialLoading) {
    return <SlotPickerSkeleton />;
  }

  return (
    <Container>
      <DaysCarousel />
      {services.length > 0 && (
        <TimeSlotPicker day={selectedDay} onClick={setSelectedTimeslot} />
      )}
    </Container>
  );
}

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'slot-picker',
    element: 'container'
  })
})`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
